import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  // Load translations using HTTP backend (lazy loading)
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'wizard', 'dashboard', 'criteria', 'participants'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator'],
      // Cache user language preference
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    backend: {
      // Path to load translation files from public directory
      loadPath: '/locales/{{lng}}/{{ns}}.json',

      // Request options
      requestOptions: {
        cache: 'no-cache', // Disable caching in development
      },
    },

    // Preload only the default language and detected language
    // This reduces initial bundle size
    preload: ['en'],

    // Load namespaces on demand
    // Only loads the namespaces that are actually used
    partialBundledLanguages: true,

    // Development options
    debug: false,

    // Return empty string for missing keys in non-English languages
    // This allows fallback to English to work properly
    returnEmptyString: false,

    // React-specific options
    react: {
      // Suspense mode - shows loading state while translations load
      useSuspense: true,
    },
  });

// Update HTML lang attribute when language changes (WCAG 3.1.1, 3.1.2)
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
